module.exports = __webpack_public_path__ + "img/p_12.963e5815.png";